// extracted by mini-css-extract-plugin
export default {"app":"app_app__9SwR3","main":"app_main__k9bsR","footer":"app_footer__Ypxm5"};